import { FormApplicationTypeEnum } from '../../../models';

type FormLocalizationType = {
  [key in FormApplicationTypeEnum]: {
    en: string;
    nn: string;
    nb: string;
  };
};

export const formIdentifiers: FormLocalizationType = {
  [FormApplicationTypeEnum.ReleaseOfCollaterals]: {
    en: 'release of collaterals',
    nn: 'fråfall av tryggleik',
    nb: 'frafall av sikkerhet',
  },
  [FormApplicationTypeEnum.PayoutRequestGrant]: {
    en: 'payout request (grant)',
    nn: 'utbetalingsførespurnad (tilskot)',
    nb: 'utbetalingsforespørsel (tilskudd)',
  },
  [FormApplicationTypeEnum.FinalReportGrant]: {
    en: 'final report (grant)',
    nn: 'sluttrapport (tilskot)',
    nb: 'sluttrapport (tilskudd)',
  },
  [FormApplicationTypeEnum.FinalReportGrantSimple]: {
    en: 'final report (grant)',
    nn: 'sluttrapport (tilskot)',
    nb: 'sluttrapport (tilskudd)',
  },
  [FormApplicationTypeEnum.PayoutRequestStartupLoan]: {
    en: 'payout request (startup loan)',
    nn: 'utbetalingsførespurnad (oppstartslån)',
    nb: 'utbetalingsforespørsel (oppstartslån)',
  },
  [FormApplicationTypeEnum.CustomerUploadsRequiredDocumentation]: {
    en: 'customer uploads required documentation',
    nn: 'kunde lastar opp nødvendig dokumentasjon',
    nb: 'kunde laster opp nødvendig dokumentasjon',
  },
  [FormApplicationTypeEnum.AmortizationDelay]: {
    en: 'amortization delay',
    nn: 'utsetjing av nedbetaling',
    nb: 'utsettelse av nedbetaling',
  },
  [FormApplicationTypeEnum.DeMinimisAid]: {
    en: 'de minimis aid',
    nn: 'bagatellmessig støtte',
    nb: 'bagatellmessig støtte',
  },
  [FormApplicationTypeEnum.DeferralPayment]: {
    en: 'deferral of payment',
    nn: 'utsetjing av betaling',
    nb: 'utsettelse av betaling',
  },
  [FormApplicationTypeEnum.GeneralApplicationAdditionalInformation]: {
    en: 'additional information (general application)',
    nn: 'tilleggsinformasjon (generell søknad)',
    nb: 'tilleggsinformasjon (generell søknad)',
  },
  [FormApplicationTypeEnum.InflowSelfDeclaration]: {
    en: 'self-declaration of inflow',
    nn: 'eiga fråsegn om innstrøyming',
    nb: 'egen erklæring om innstrømming',
  },
  [FormApplicationTypeEnum.Complaint]: {
    en: 'complaint',
    nn: 'klage',
    nb: 'klage',
  },
  [FormApplicationTypeEnum.ConferenceAttendance]: {
    en: 'conference attendance',
    nn: 'deltaking på konferanse',
    nb: 'deltakelse på konferanse',
  },
  [FormApplicationTypeEnum.ConferenceOrganizeAbroad]: {
    en: 'organize conference abroad',
    nn: 'organisere konferanse i utlandet',
    nb: 'organisere konferanse i utlandet',
  },
  [FormApplicationTypeEnum.ConferenceOrganizeIncoming]: {
    en: 'organize incoming conference',
    nn: 'organisere innkomande konferanse',
    nb: 'organisere innkommende konferanse',
  },
  [FormApplicationTypeEnum.GeneralApplicationPayoutRequest]: {
    en: 'general application payout request',
    nn: 'generell søknad utbetalingsførespurnad',
    nb: 'generell søknad utbetalingsforespørsel',
  },
  [FormApplicationTypeEnum.GeneralApplicationAdditionalInformationPayoutRequest]: {
    en: 'additional information for payout request (general application)',
    nn: 'tilleggsinformasjon for utbetalingsførespurnad (generell søknad)',
    nb: 'tilleggsinformasjon for utbetalingsforespørsel (generell søknad)',
  },
  [FormApplicationTypeEnum.ApplicationMaintenanceAmortizationDelay]: {
    en: 'application maintenance - amortization delay',
    nn: 'vedlikehald av søknad - utsetjing av nedbetaling',
    nb: 'vedlikehold av søknad - utsettelse av nedbetaling',
  },
  [FormApplicationTypeEnum.PayoutRequestGrantOpusBioe]: {
    en: 'payout request (Opus BioE grant)',
    nn: 'utbetalingsførespurnad (Opus BioE-tilskot)',
    nb: 'utbetalingsforespørsel (Opus BioE-tilskudd)',
  },
  [FormApplicationTypeEnum.PayoutRequestGrantOpusTrl]: {
    en: 'payout request (Opus TRL grant)',
    nn: 'utbetalingsførespurnad (Opus TRL-tilskot)',
    nb: 'utbetalingsforespørsel (Opus TRL-tilskudd)',
  },
  [FormApplicationTypeEnum.PayoutRequestGrantOpusMatil]: {
    en: 'payout request (Opus Matil grant)',
    nn: 'utbetalingsførespurnad (Opus Matil-tilskot)',
    nb: 'utbetalingsforespørsel (Opus Matil-tilskudd)',
  },
  [FormApplicationTypeEnum.PayoutRequestGrantConferenceAttendance]: {
    en: 'payout request (conference attendance grant)',
    nn: 'utbetalingsførespurnad (tilskot for konferansedeltaking)',
    nb: 'utbetalingsforespørsel (tilskudd for konferansedeltakelse)',
  },
  [FormApplicationTypeEnum.InflowFillInInsuranceMovables]: {
    en: 'fill in insurance for movables',
    nn: 'fyll ut forsikring for lausøyre',
    nb: 'fyll ut forsikring for løsøre',
  },
  [FormApplicationTypeEnum.PayoutRequestLoanShippingFishing]: {
    en: 'payout request (loan for shipping/fishing)',
    nn: 'utbetalingsførespurnad (lån for skipsfart/fiske)',
    nb: 'utbetalingsforespørsel (lån for skipsfart/fiske)',
  },
  [FormApplicationTypeEnum.ProjectAccounting]: {
    en: 'project accounting',
    nn: 'prosjektrekneskap',
    nb: 'prosjektregnskap',
  },
  [FormApplicationTypeEnum.PayoutRequestGrantHIP]: {
    en: 'payout request (HIP grant)',
    nn: 'utbetalingsførespurnad (HIP-tilskot)',
    nb: 'utbetalingsforespørsel (HIP-tilskudd)',
  },
  [FormApplicationTypeEnum.PayoutRequestGrantSimple]: {
    en: 'payout request (grant)',
    nn: 'utbetalingsførespurnad (tilskot)',
    nb: 'utbetalingsforespørsel (tilskudd)',
  },
  [FormApplicationTypeEnum.MentorSupportPayout]: {
    en: 'mentor support payout',
    nn: 'utbetaling av mentorstøtte',
    nb: 'utbetaling av mentorstøtte',
  },
  [FormApplicationTypeEnum.MaintenancePriorityDeviation]: {
    en: 'Priority deviation',
    nn: 'Prioritetsviking',
    nb: 'Prioritetsvikelse',
  },
  [FormApplicationTypeEnum.DeMinimisAidV2]: {
    en: 'de minimis aid',
    nn: 'bagatellmessig støtte',
    nb: 'bagatellmessig støtte',
  },
  [FormApplicationTypeEnum.ApplicationGrantIncomeLoss]: {
    en: 'application for grant (income loss)',
    nn: 'søknad om tilskot (inntektstap)',
    nb: 'søknad om tilskudd (inntektstap)',
  },
  [FormApplicationTypeEnum.PayoutRequestGrantMatil]: {
    en: 'payout request (Matil grant)',
    nn: 'utbetalingsførespurnad (Matil-tilskot)',
    nb: 'utbetalingsforespørsel (Matil-tilskudd)',
  },
  [FormApplicationTypeEnum.PayoutRequestLoan]: {
    en: 'payout request (loan)',
    nn: 'utbetalingsførespurnad (lån)',
    nb: 'utbetalingsforespørsel (lån)',
  },
  [FormApplicationTypeEnum.MaintenanceAmendmentOfTerms]: {
    en: 'Change of terms for loan/grant',
    nn: 'Endring av vilkår for lån/tilskot',
    nb: 'Endring av vilkår for lån/tilskudd',
  },
  [FormApplicationTypeEnum.None]: {
    en: 'none',
    nn: 'ingen',
    nb: 'ingen',
  },
} as const;
